import * as React from 'react'
import { IATooltip } from "./Tooltip";

export interface IAConditionalTooltipWrapperProps {
  condition: boolean;
  tooltipContent: any;
  wrapper: (content) => any;
}

export class IAConditionalTooltipWrapper  extends React.Component<IAConditionalTooltipWrapperProps> {

  constructor(props: IAConditionalTooltipWrapperProps) {
    super(props)
  }


  public render(): JSX.Element {

    return (
      <>
        {this.props.condition ? 
        <IATooltip
          content="Tooltip"
          type={"followMouse"}
          styles={{
            width: 150,
            textAlign: "center",
            position:"fixed",
            height: "35px",
            lineHeight: "17px"
          }}
          componentContent={
            this.props.tooltipContent
          }
        >
          {this.props.wrapper(this.props.children)}
        </IATooltip>
        :
        this.props.children
        }
      </>
    );
  }
}